import React from "react";
import "./Styles.css";
import minhaFoto from "../../imagens/wellington.jpg";
 // Use a versão com fundo

const Sobremim = () => {
  return (
    <section className="sobremim-section">
      <div className="sobremim-container">
        <div className="sobremim-text">
          <h2>Sobre Mim</h2>
          <p>
            Olá! Sou Wellington, especialista em manutenção de computadores e notebooks em Pilar do Sul. 
            Tenho anos de experiência em formatação, upgrades e suporte técnico de alta qualidade.
          </p>
          <p>
            Meu objetivo é oferecer soluções rápidas e eficientes para você aproveitar ao máximo seus dispositivos.
          </p>
        </div>
        <div className="sobremim-foto-container">
          <img src={minhaFoto} alt="Wellington" className="sobremim-foto" />
        </div>
      </div>
    </section>
  );
};

export default Sobremim;
